import { useState } from "react";
import axios from "axios";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

import { APP_API_V1_BASE } from "../../../config/api";
const API_BASE = `${APP_API_V1_BASE}/firmware/deployments`;

export default function RollbackModal({
  open,
  onClose,
  deploymentId,
  rollbackCandidate,
  headers,
  onSuccess,
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleConfirm = async () => {
    if (!deploymentId) return;
    setLoading(true);
    setError("");
    try {
      const response = await axios.post(
        `${API_BASE}/${deploymentId}/rollback`,
        {},
        { headers },
      );
      onSuccess?.(response?.data);
      onClose?.();
    } catch (e) {
      setError(e?.response?.data?.error || "Rollback failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle sx={{ fontWeight: 800 }}>
        Create Rollback Deployment
      </DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 1.5 }}>
            {error}
          </Alert>
        )}

        <Typography color="#5A6E91" fontSize={13} mb={1}>
          This will create a new deployment to roll devices back to the previous
          firmware version.
        </Typography>

        <Box
          sx={{
            p: 1.4,
            borderRadius: "10px",
            border: "1px solid #DEE8F8",
            background: "#F4F8FF",
          }}
        >
          <Typography fontWeight={700} color="#244A86" fontSize={13}>
            Target rollback firmware
          </Typography>
          <Typography fontSize={13} mt={0.4}>
            {rollbackCandidate?.name || "—"} · v
            {rollbackCandidate?.version || "—"}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.2 }}>
        <Button
          onClick={onClose}
          disabled={loading}
          variant="outlined"
          sx={{ textTransform: "none" }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          disabled={loading || !rollbackCandidate}
          variant="contained"
          sx={{ textTransform: "none" }}
        >
          {loading ? "Creating…" : "Confirm Rollback"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
